import { useInternationalization } from '@progress/kendo-react-intl';
import { useMemo } from 'react';
import ModalContentPreference from 'src/components/ModalContentPreference';
import NumberInput from 'src/components/NumberInput';
import PopUp from 'src/components/design-system/PopUp';
import { getBgColor, getIcon } from 'src/utils/icons';
import { useContextSelector } from 'use-context-selector';
import { InvoiceContext } from '../InvoiceDetailsContext';
import OcrIndicator from '../split_line_item/OcrIndicator';

const Discount = () => {
  const invoice = useContextSelector(InvoiceContext, (value) => value.invoice);
  const handleInputChange = useContextSelector(InvoiceContext, (value) => value.handleInputChange);
  const warnings = useContextSelector(InvoiceContext, (value) => value.warnings);
  const isInvoiceEditDisabled = useContextSelector(
    InvoiceContext,
    (value) => value.isInvoiceEditDisabled
  );
  const ocrResponse = useContextSelector(InvoiceContext, (value) => value.ocrResponse);
  const initialInvoice = useContextSelector(InvoiceContext, (value) => value.initialInvoice);
  const handleHoverOcrField = useContextSelector(
    InvoiceContext,
    (value) => value.handleHoverOcrField
  );
  const errors = useContextSelector(InvoiceContext, (value) => value.errors);
  const hasWarning = useMemo(() => !!warnings.discountAmt.length, [warnings.discountAmt.length]);

  const hasError = useMemo(() => !!errors.discountAmt.length, [errors.discountAmt.length]);
  const intl = useInternationalization();

  const isEdited = useMemo(
    () => Number(ocrResponse.totalDiscount?.value || 0) !== Number(invoice?.discountAmt || 0),
    [invoice.discountAmt, ocrResponse.totalDiscount?.value]
  );

  return (
    <PopUp
      content={
        <ModalContentPreference
          hasWarning={hasWarning}
          hasError={hasError}
          warningContent={warnings.discountAmt}
          errorContent={errors.discountAmt}
        />
      }
      show={hasError || hasWarning}
      popupAlign={{ horizontal: 'center', vertical: 'bottom' }}
      anchorAlign={{ horizontal: 'right', vertical: 'top' }}
    >
      <div className={`p-1 ${getBgColor(errors.discountAmt, warnings.discountAmt)} text-[13px] `}>
        <div className="flex justify-between max-w-[177px] flex-grow">
          <p className="font-bold flex items-center pb-1">
            Discount
            <span className="px-2">{getIcon(errors.discountAmt, warnings.discountAmt)}</span>
          </p>
          {initialInvoice?.ocrGenerated && ocrResponse.totalDiscount?.confidence && (
            <OcrIndicator
              isEdited={isEdited}
              ocrConfidence={ocrResponse.totalDiscount?.confidence}
              onHover={() => handleHoverOcrField('totalDiscount')}
            />
          )}
        </div>
        {isInvoiceEditDisabled ? (
          <p title={invoice?.discountAmt?.toString() || ''}>
            {intl.format('{0:c2}', Number(invoice?.discountAmt) || 0)}{' '}
          </p>
        ) : (
          <NumberInput
            title={invoice?.discountAmt?.toString() || ''}
            value={invoice?.discountAmt.toString()}
            onChange={handleInputChange('discountAmt')}
            valid={!(hasWarning || hasError)}
            prefix="$"
            onFocus={() => handleHoverOcrField('totalDiscount')}
            ocr-data="totalDiscount"
          />
        )}
      </div>
    </PopUp>
  );
};

export default Discount;
